module.exports = __webpack_public_path__ + "b395cc1e8f5e2c83c00ef26108e30920.svg";